module.exports = require("@grpc/grpc-js");